module.exports = __webpack_public_path__ + "img/Dantam Hair 23.bb3a66d9.jpg";